// Category icon and color suggestions based on category name
// Maps common category names/keywords to appropriate emoji icons and colors

const CATEGORY_MAPPINGS = {
  // Income categories
  salary: { icon: '💼', color: '#10B981' },
  wage: { icon: '💼', color: '#10B981' },
  income: { icon: '💰', color: '#10B981' },
  bonus: { icon: '🎁', color: '#F59E0B' },
  freelance: { icon: '💻', color: '#8B5CF6' },
  investment: { icon: '📈', color: '#3B82F6' },
  dividend: { icon: '💹', color: '#10B981' },
  interest: { icon: '🐷', color: '#6366F1' },
  rental: { icon: '🏠', color: '#EC4899' },
  rent: { icon: '🏠', color: '#EC4899' },
  refund: { icon: '🧾', color: '#14B8A6' },
  cashback: { icon: '💵', color: '#22C55E' },
  gift: { icon: '🎁', color: '#F472B6' },
  reward: { icon: '⭐', color: '#FBBF24' },

  // Food & Dining
  food: { icon: '🍽️', color: '#F97316' },
  dining: { icon: '🍽️', color: '#F97316' },
  restaurant: { icon: '🍽️', color: '#EF4444' },
  groceries: { icon: '🛒', color: '#22C55E' },
  grocery: { icon: '🛒', color: '#22C55E' },
  coffee: { icon: '☕', color: '#92400E' },
  cafe: { icon: '☕', color: '#92400E' },
  snacks: { icon: '🧁', color: '#FB923C' },

  // Transport
  transport: { icon: '🚗', color: '#3B82F6' },
  transportation: { icon: '🚗', color: '#3B82F6' },
  travel: { icon: '✈️', color: '#0EA5E9' },
  car: { icon: '🚗', color: '#6366F1' },
  auto: { icon: '🚗', color: '#6366F1' },
  fuel: { icon: '⛽', color: '#EF4444' },
  petrol: { icon: '⛽', color: '#EF4444' },
  gas: { icon: '⛽', color: '#EF4444' },
  uber: { icon: '🚕', color: '#000000' },
  ola: { icon: '🚕', color: '#22C55E' },
  taxi: { icon: '🚕', color: '#FBBF24' },
  metro: { icon: '🚃', color: '#3B82F6' },
  train: { icon: '🚃', color: '#6366F1' },
  bus: { icon: '🚌', color: '#10B981' },
  flight: { icon: '✈️', color: '#0EA5E9' },
  parking: { icon: '🚗', color: '#64748B' },
  bike: { icon: '🏍️', color: '#64748B' },

  // Shopping
  shopping: { icon: '🛍️', color: '#EC4899' },
  clothes: { icon: '👗', color: '#8B5CF6' },
  clothing: { icon: '👗', color: '#8B5CF6' },
  fashion: { icon: '👗', color: '#EC4899' },
  amazon: { icon: '🛒', color: '#F97316' },
  online: { icon: '🛒', color: '#3B82F6' },
  electronics: { icon: '📱', color: '#6366F1' },
  gadgets: { icon: '📱', color: '#3B82F6' },
  jewelry: { icon: '💎', color: '#EC4899' },
  accessories: { icon: '👜', color: '#64748B' },

  // Home & Utilities
  home: { icon: '🏠', color: '#8B5CF6' },
  house: { icon: '🏠', color: '#8B5CF6' },
  electricity: { icon: '⚡', color: '#FBBF24' },
  electric: { icon: '⚡', color: '#FBBF24' },
  water: { icon: '💧', color: '#0EA5E9' },
  internet: { icon: '📶', color: '#3B82F6' },
  wifi: { icon: '📶', color: '#3B82F6' },
  phone: { icon: '📱', color: '#10B981' },
  mobile: { icon: '📱', color: '#10B981' },
  recharge: { icon: '📱', color: '#22C55E' },
  utility: { icon: '⚡', color: '#F59E0B' },
  utilities: { icon: '⚡', color: '#F59E0B' },
  maintenance: { icon: '🔧', color: '#64748B' },
  furniture: { icon: '🏠', color: '#92400E' },

  // Health & Fitness
  health: { icon: '❤️', color: '#EF4444' },
  medical: { icon: '🏥', color: '#EF4444' },
  medicine: { icon: '💊', color: '#10B981' },
  pharmacy: { icon: '💊', color: '#22C55E' },
  doctor: { icon: '🩺', color: '#3B82F6' },
  hospital: { icon: '🏥', color: '#EF4444' },
  gym: { icon: '🏋️', color: '#F97316' },
  fitness: { icon: '🏋️', color: '#EF4444' },
  yoga: { icon: '🧘', color: '#8B5CF6' },
  sports: { icon: '🏋️', color: '#22C55E' },

  // Personal Care
  salon: { icon: '💆', color: '#EC4899' },
  haircut: { icon: '💆', color: '#6366F1' },
  spa: { icon: '💆', color: '#EC4899' },
  beauty: { icon: '💆', color: '#F472B6' },
  grooming: { icon: '💆', color: '#64748B' },
  'personal care': { icon: '💆', color: '#F472B6' },

  // Entertainment
  entertainment: { icon: '🎬', color: '#8B5CF6' },
  movie: { icon: '🎬', color: '#EF4444' },
  movies: { icon: '🎬', color: '#EF4444' },
  netflix: { icon: '📺', color: '#DC2626' },
  streaming: { icon: '📺', color: '#6366F1' },
  subscription: { icon: '📺', color: '#3B82F6' },
  subscriptions: { icon: '📺', color: '#3B82F6' },
  music: { icon: '🎵', color: '#22C55E' },
  spotify: { icon: '🎵', color: '#22C55E' },
  gaming: { icon: '🎮', color: '#8B5CF6' },
  games: { icon: '🎮', color: '#6366F1' },

  // Education
  education: { icon: '🎓', color: '#3B82F6' },
  school: { icon: '🎓', color: '#6366F1' },
  college: { icon: '🎓', color: '#8B5CF6' },
  course: { icon: '📚', color: '#10B981' },
  courses: { icon: '📚', color: '#10B981' },
  books: { icon: '📚', color: '#92400E' },
  book: { icon: '📚', color: '#92400E' },
  tuition: { icon: '🎓', color: '#F59E0B' },
  training: { icon: '🎓', color: '#3B82F6' },

  // Family & Kids
  kids: { icon: '👶', color: '#EC4899' },
  baby: { icon: '👶', color: '#F472B6' },
  children: { icon: '👶', color: '#8B5CF6' },
  toys: { icon: '👶', color: '#F97316' },
  family: { icon: '👨‍👩‍👧', color: '#EC4899' },

  // Pets
  pet: { icon: '🐶', color: '#F97316' },
  pets: { icon: '🐶', color: '#F97316' },
  dog: { icon: '🐶', color: '#92400E' },
  cat: { icon: '🐱', color: '#64748B' },
  vet: { icon: '🩺', color: '#10B981' },

  // Finance & Insurance
  insurance: { icon: '🏦', color: '#3B82F6' },
  emi: { icon: '💳', color: '#EF4444' },
  loan: { icon: '🏛️', color: '#F59E0B' },
  tax: { icon: '🧾', color: '#64748B' },
  taxes: { icon: '🧾', color: '#64748B' },
  bank: { icon: '🏛️', color: '#3B82F6' },
  fees: { icon: '🧾', color: '#EF4444' },
  transfer: { icon: '💸', color: '#6366F1' },

  // Work & Business
  office: { icon: '🏢', color: '#6366F1' },
  work: { icon: '💼', color: '#3B82F6' },
  business: { icon: '🏢', color: '#64748B' },
  client: { icon: '💼', color: '#10B981' },

  // Misc
  charity: { icon: '❤️', color: '#EC4899' },
  donation: { icon: '❤️', color: '#EF4444' },
  tips: { icon: '💵', color: '#22C55E' },
  miscellaneous: { icon: '📌', color: '#64748B' },
  misc: { icon: '📌', color: '#64748B' },
  other: { icon: '📌', color: '#64748B' },
  others: { icon: '📌', color: '#64748B' },
};

// Default suggestions based on type
const DEFAULT_EXPENSE = { icon: '🏷️', color: '#6366F1' };
const DEFAULT_INCOME = { icon: '💰', color: '#10B981' };

/**
 * Get suggested icon and color based on category name
 * @param {string} name - Category name to analyze
 * @param {string} type - Category type ('income' or 'expense')
 * @returns {{ icon: string, color: string }} Suggested icon and color
 */
export function suggestIconAndColor(name, type = 'expense') {
  if (!name || typeof name !== 'string') {
    return type === 'income' ? DEFAULT_INCOME : DEFAULT_EXPENSE;
  }

  const normalizedName = name.toLowerCase().trim();

  // Check for exact match first
  if (CATEGORY_MAPPINGS[normalizedName]) {
    return CATEGORY_MAPPINGS[normalizedName];
  }

  // Check if any keyword is contained in the name
  for (const [keyword, suggestion] of Object.entries(CATEGORY_MAPPINGS)) {
    if (normalizedName.includes(keyword)) {
      return suggestion;
    }
  }

  // Check if name contains any keyword
  const words = normalizedName.split(/[\s&,/-]+/);
  for (const word of words) {
    if (word.length > 2 && CATEGORY_MAPPINGS[word]) {
      return CATEGORY_MAPPINGS[word];
    }
  }

  // Return default based on type
  return type === 'income' ? DEFAULT_INCOME : DEFAULT_EXPENSE;
}

/**
 * Check if a suggestion is different from current values
 */
export function hasSuggestion(name, type, currentIcon, currentColor) {
  const suggestion = suggestIconAndColor(name, type);
  return suggestion.icon !== currentIcon || suggestion.color !== currentColor;
}
